<mat-card class="order-medicine-list-view">
  <div class="row">
    <div class="col-md-3">
      <mat-card-title>Order medicine</mat-card-title>
    </div>
    <div class="col-md-9 text-end">
      <mat-form-field appearance="outline">
        <mat-label>Search medicine</mat-label>
        <input
          matInput
          placeholder="Start typing..."
          [formControl]="searchInput"
        />
        <mat-icon matPrefix>search</mat-icon>
      </mat-form-field>
    </div>
  </div>

  <mat-paginator
    [length]="totalItems"
    [pageIndex]="page - 1"
    [pageSize]="limit"
    [pageSizeOptions]="[10, 15, 20]"
    showFirstLastButtons
    (page)="onPageChange($event)"
    aria-label="Select page of order medicine"
  >
  </mat-paginator>

  <div class="py-2">
    <mat-divider></mat-divider>
  </div>
  
  <div class="medicine-list-container">
    <core-order-medicine-item-list (onDelete)="removeOrderItem($event)" [orderItems]="orderItems"
      [orderItemStatuses]="orderItemStatuses" [batchStatuses]="batchStatuses"></core-order-medicine-item-list>
  </div>
</mat-card> 